import React from "react";
import { api, getToken, setToken, clearToken } from "../services/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Target, LogOut, Lock } from "lucide-react";
import ResultsAdmin from "../components/admin/ResultsAdmin";
import CommonNumberAdmin from "../components/admin/CommonNumberAdmin";

function Login({ onDone }) {
  const [u, setU] = React.useState("");
  const [p, setP] = React.useState("");
  const [err, setErr] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const data = await api.login(u, p);
      setToken(data.token);
      onDone();
    } catch (e2) {
      setErr("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl shadow-lg border border-gray-100 p-7">
        <div className="flex flex-col items-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#e8491d] flex items-center justify-center mb-3">
            <Lock className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-xl font-black text-[#1f2733]">Admin Login</h1>
          <p className="text-xs text-gray-400 mt-1">Sunday Ground Teer Management</p>
        </div>
        <label className="block text-sm font-bold text-gray-600 mb-1">Username</label>
        <input
          value={u}
          onChange={(e) => setU(e.target.value)}
          className="w-full mb-4 px-4 py-2.5 rounded-xl border border-gray-300 outline-none focus:border-[#e8491d] focus:ring-2 focus:ring-[#e8491d]/30"
          placeholder="admin"
        />
        <label className="block text-sm font-bold text-gray-600 mb-1">Password</label>
        <input
          type="password"
          value={p}
          onChange={(e) => setP(e.target.value)}
          className="w-full mb-4 px-4 py-2.5 rounded-xl border border-gray-300 outline-none focus:border-[#e8491d] focus:ring-2 focus:ring-[#e8491d]/30"
          placeholder="••••••••"
        />
        {err && <p className="text-sm text-red-500 mb-3">{err}</p>}
        <button
          disabled={loading}
          className="w-full py-3 rounded-xl bg-[#e8491d] text-white font-bold hover:bg-[#c53a12] transition-colors disabled:opacity-60"
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default function Admin() {
  const [authed, setAuthed] = React.useState(!!getToken());

  const logout = () => {
    clearToken();
    setAuthed(false);
  };

  const onAuthError = () => {
    clearToken();
    setAuthed(false);
  };

  if (!authed) return <Login onDone={() => setAuthed(true)} />;

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-full bg-[#e8491d] flex items-center justify-center">
            <Target className="w-6 h-6 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="text-xl font-black text-[#1f2733]">Admin Dashboard</h1>
        </div>
        <button
          onClick={logout}
          className="flex items-center gap-1.5 px-4 py-2 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-sm transition-colors"
        >
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </div>

      <Tabs defaultValue="results">
        <TabsList className="grid grid-cols-2 w-full mb-5">
          <TabsTrigger value="results">Results</TabsTrigger>
          <TabsTrigger value="common">Common No.</TabsTrigger>
        </TabsList>
        <TabsContent value="results">
          <ResultsAdmin onAuthError={onAuthError} />
        </TabsContent>
        <TabsContent value="common">
          <CommonNumberAdmin onAuthError={onAuthError} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
